const EXPORT_VERSION = 1;

function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeCsvValue(value) {
  if (value === null || value === undefined) return '';
  const stringValue = Array.isArray(value) ? value.join('|') : String(value);
  return `"${stringValue.replace(/"/g, '""')}"`;
}

export function createExportPayload({ tasks, projects, tags, settings }) {
  return {
    app: 'Efficacitas',
    version: EXPORT_VERSION,
    exportedAt: new Date().toISOString(),
    data: {
      tasks,
      projects,
      tags,
      settings
    }
  };
}

export function downloadFullJsonExport(data) {
  const payload = createExportPayload(data);
  downloadBlob(
    JSON.stringify(payload, null, 2),
    `efficacitas_export_${new Date().toISOString().slice(0, 10)}.json`,
    'application/json'
  );
}

export function downloadTasksCsv(tasks, projects, tags) {
  const projectById = new Map(projects.map(project => [project.id, project.name]));
  const tagById = new Map(tags.map(tag => [tag.id, tag.name]));
  const headers = [
    'id',
    'title',
    'description',
    'project',
    'priority',
    'completed',
    'completedAt',
    'archived',
    'archivedAt',
    'dueDate',
    'endDate',
    'startTime',
    'duration',
    'tags',
    'subtasks'
  ];

  const rows = tasks.map(task => [
    task.id,
    task.title,
    task.description,
    projectById.get(task.projectId) || task.projectId || '',
    task.priority,
    task.completed ? 'true' : 'false',
    task.completedAt || '',
    task.archived ? 'true' : 'false',
    task.archivedAt || '',
    task.dueDate || '',
    task.endDate || '',
    task.startTime || '',
    task.duration || '',
    (task.tags || []).map(tagId => tagById.get(tagId) || tagId),
    (task.subTasks || []).map(subtask => subtask.title)
  ]);

  const csv = [
    headers.map(escapeCsvValue).join(','),
    ...rows.map(row => row.map(escapeCsvValue).join(','))
  ].join('\n');

  downloadBlob(
    csv,
    `efficacitas_tasks_${new Date().toISOString().slice(0, 10)}.csv`,
    'text/csv;charset=utf-8'
  );
}

export async function parseJsonImport(file) {
  const text = await file.text();
  const parsed = JSON.parse(text);
  const data = parsed.data || parsed;

  if (!Array.isArray(data.tasks) || !Array.isArray(data.projects) || !Array.isArray(data.tags)) {
    throw new Error('Invalid Efficacitas export: tasks, projects and tags arrays are required.');
  }

  return {
    tasks: data.tasks,
    projects: data.projects,
    tags: data.tags,
    settings: data.settings || {}
  };
}
